import React, { Children } from "react";

import { Para } from "./Para";
import { TypographyProps } from "@mui/material";

export const Paras = ({ children }: { children?: React.ReactNode }) => {
  const size = Children.count(children) - 1;

  const childrenWithProps = React.Children.map(children, (child, idx) => {
    if (React.isValidElement(child) && idx < size) {
      const typedChild = child as React.ReactElement<{ paragraph?: boolean }>;
      const explicitNoParagaph = typedChild.props.paragraph === false;
      const para = !explicitNoParagaph;

      return typedChild.type === Para
        ? React.cloneElement(typedChild, { paragraph: para } as TypographyProps)
        : child;
    }
    return child;
  });

  return <>{childrenWithProps}</>;
};
